<template>
  <div class="multi-button-cont" :id="id" ref="cont">
    <ButtonVue
      class="primary-btn"
      ref="primaryBtn"
      :label="label"
      @btn-click="onBtnClick"
      :size="size">
    </ButtonVue>

    <div class="buttons-cont hide" ref="buttons">
      <ButtonVue 
        v-for="btn in options"
        :label="btn.label"
        type="outline"
        :size="size"
        :data="btn.data"
        @btn-click="onMultiBtnClick($event, btn)">
      </ButtonVue>
    </div>
 </div>
</template>

<script>
import ButtonVue from './ButtonVue'

export default {
  name: "MultiButtonVue",

  props:{
    id: String,
    size: {
      type: String,
        default: 'square'
    },
    type: String,
    label: {
      type: String,
      default: '<i class="material-symbols-outlined">add</i>'
    },
    options: Array,
  },

  data() {
    return {}
  },

  methods: {
    onBtnClick(evt) {
      this.toggleBtn(evt)
    },

    onMultiBtnClick(evt, btn) {
      this.toggleBtn(evt)
      btn.click(evt.event, evt.name)
    },

    toggleBtn(evt) {
      const frameHeight = document.documentElement.clientHeight
      const frameWidth = document.documentElement.clientWidth
      const toggleDimensions = this.$refs.cont.getBoundingClientRect()
      const buttonDimensions = this.$refs.buttons.getBoundingClientRect()
      // add 50 to account for padding/margins
      if (frameHeight < toggleDimensions.bottom + buttonDimensions.height + 50) {
        this.$refs.buttons.style.bottom = '60px'
      } else { 
        this.$refs.buttons.style.top = '60px'
      }

      if (frameWidth < toggleDimensions.right + buttonDimensions.width + 50) {
        this.$refs.buttons.style.right = 0
      } else {
        this.$refs.buttons.style.left = 0
      }

      this.$refs.buttons.classList.toggle('hide')
      this.$refs.cont.classList.toggle('rotate45')
    },
  },

  created() {
  },

  components: {
    ButtonVue
  }
}
</script>

<style lang="scss">
.multi-button-cont {
  position: relative;

  .buttons-cont {
    position: absolute;
    padding: $padding;
    background-color: $dark-mode-surface;
    border: 1px solid $color-primary-dark;
    border-radius: $border-radius;

    .hide {
      display: none;
    }

    .btn-cont {
      margin: $margin 0;
    }
  }

  .primary-btn {
    .btn {
      i.material-symbols-outlined {
        transition: transform 0.25s;
      }
    }
  }

  &.rotate45 {
    .primary-btn {
      .btn {
        i.material-symbols-outlined {
          transform: rotate(45deg);
          display: inline-block;
        }
      }
    }
  }
}
</style>
